import React, { useEffect, useState } from "react";
import * as IMAGES from "./images";
import "./Header.css";

function Header() {
  // const slideImage = () => {
  //   let count = 0;
  //   let element = document.getElementById("background-slider");
  //   setInterval(() => {
  //     ++count;
  //     element.style.background = "url(" + IMAGES[count] + ")";
  //     element.style.backgroundRepeat = "round";
  //     element.style.transition = "background-image 1s ease-in-out";
  //     if (count === IMAGES.length - 1) {
  //       count = 0;
  //     }
  //   }, 5000);
  // };

  // useEffect(() => {
  //   slideImage();
  // }, []);

  const contacts = [
    {
      isImg: true,
      url: require("../img/logo/linkedin.png"),
      link: "https://www.linkedin.com/in/indrakant23",
      title: "LinkedIn",
    },
    {
      class: "fa-github",
      link: "https://github.com/indrakantm23",
      title: "Github",
    },
    {
      isImg: true,
      url: require("../img/logo/stackoverflow.png"),
      link: "https://stackoverflow.com/users/10975711/indrakant",
      title: "Stack Overflow",
    },
    {
      isImg: true,
      url: require("../img/logo/leetcode.png"),
      link: "https://leetcode.com/Indrakant/",
      title: "Leetcode",
    },
  ];

  return (
    <div>
      <div className="title-container" id="background-slider">
        <div>
          <h4 className="hello">Hello, i am </h4>
          <h1 className="name">Indrakant Mishra</h1>
          <hr className="style-two" />
          <span className="tagline">
            <span style={{ color: "#ddd" }}>Software Development Engineer</span>{" "}
            at&nbsp;
            <a
              href="https://www.deloittedigital.com/"
              target="_blank"
              className="company"
            >
              Deloitte digital
            </a>
          </span>
        </div>
        <div className="contact-icon">
          {contacts.map((item) => {
            return (
              <>
                <a href={item.link} title={item.title} target="_blank">
                  {item.isImg ? (
                    <img src={item.url} />
                  ) : (
                    <i class={`fa ${item.class}`}></i>
                  )}
                </a>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Header;
